module.exports = __webpack_public_path__ + "static/media/iconShare--facebook.19f67a4e.svg";